import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { adminBaseUrl } from "../routes";
import { headerWithAuthToken } from "../headers";
import {
    getAllDesignation,
    getSingleDesignation,
    addDesignation,
    deleteDesignation,
    editDesignation
} from "./queries";

const designationApi = createApi({
    reducerPath: "designationApi",
    baseQuery: fetchBaseQuery({
        baseUrl: adminBaseUrl,
        prepareHeaders: headerWithAuthToken,
    }),
    endpoints: (builder) => ({
        // get all users
        getAllDesignation: builder.query({
            providesTags: ["all_designations"],
            query: getAllDesignation,
        }),

        // get single user
        getSingleDesignation: builder.query({
            providesTags: ["designation"],
            query: getSingleDesignation,
        }),

        addDesignation: builder.mutation({
            invalidatesTags: ["designation"],
            query: addDesignation,
        }),

        editDesignation: builder.mutation({
            invalidatesTags: ["designation"],
            query: editDesignation,
        }),

        // delete user account
        deleteDesignation: builder.mutation({
            invalidatesTags: ["designation"],
            query: deleteDesignation,
        }),
    }),
});

export const {
    useGetAllDesignationQuery,
    useGetSingleDesignationQuery,
    useDeleteDesignationMutation,
    useAddDesignationMutation,
    useEditDesignationMutation,
    reducer: designationApiReducer,
    reducerPath: designationApiReducerPath,
    middleware: designationApiMiddleWare,
} = designationApi;
